import { render } from "./InfoModal.vue?vue&type=template&id=4aa191af&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=4aa191af&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Github\\Wellen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa191af"]])

export default __exports__